import { connect } from "react-redux";
import propsTypes from "prop-types";
import "./style.css";
import { InputLabel } from "./style";

const Textarea = ({
  name,
  value,
  className,
  labelClass,
  label,
  placeHolder,
  seq,
  onChange,
  theme,
  height,
}) => {
  const changeValue = (e) => {
    onChange(name, e.target.value);
  };

  return (
    <>
      {label ? (
        <InputLabel
          theme={theme}
          className={`d-block mb-1 ${seq ? " mr-3" : " mr-1"} ${labelClass}`}
        >
          {label}
        </InputLabel>
      ) : (
        false
      )}
      <textarea
        name={name}
        placeholder={placeHolder}
        value={value}
        style={{ height: height }}
        className={`form-control w-100 border input-default-v2 ${
          seq ? "textarea-seq" : false
        } ${theme.isDarkTheme && "dark"} ${className}`}
        onChange={(e) => changeValue(e)}
      ></textarea>
    </>
  );
};

Textarea.propsTypes = {
  name: propsTypes.string,
  value: propsTypes.string,
  className: propsTypes.string,
  labelClass: propsTypes.string,
  label: propsTypes.string,
  seq: propsTypes.bool,
  onChange: propsTypes.func,
};

Textarea.defaultProps = {
  seq: false,
  height: "auto",
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Textarea);
